/**
 * Benutzer-Service für Benutzer-Daten
 * @class service_v3sUserService
 * @memberOf v3sWbtPlayerApp:model
 */
angular.module('v3sWbtPlayerApp').factory('v3sUserService', ["$rootScope", "v3sModal", function ($rootScope, v3sModal) {

    var modal = null;
    var vars = [];
    var asked = false;
    var changed = false;

    var user = {
        id: { value: "", ask: false, asked: false, locked: false, required: false },
        title: { value: "", ask: false, asked: false, locked: false, required: false },
        forename: { value: "", ask: false, asked: false, locked: false, required: false },
        surname: { value: "", ask: false, asked: false, locked: false, required: false },
        personnelNumber: { value: "", ask: false, asked: false, locked: false, required: false },
        department: { value: "", ask: false, asked: false, locked: false, required: false },
        birthday: { value: "", ask: false, asked: false, locked: false, required: false }
    };

    function get(key) {
        var value = "";

        if (!!key) {
            var required = false;
            if (key.indexOf("*") >= 0) {
                key = key.replace("*", "");
                required = true;
            }
            if (!!user[key]) {
                user[key].ask = true;
                if (required) {
                    user[key].required = required;
                }

                if (!user[key].locked && user[key].value == "" && (user[key].required || !user[key].asked)) {
                    showUserData(true);
                }

                user[key].asked = true;
                value = user[key].value;
            }
        }

        return value;
    }

    function set(key, value, locked, required) {
        var valueChanged = false;

        if (!!user[key] && !user[key].locked) {
            valueChanged = user[key].value != value;

            user[key].value = value;
            user[key].ask = true;
            user[key].locked = !!locked;
            if (!!required) {
                user[key].required = true;
            }
        } else if (key == "name") {
            if (!!value) {
                var name, surname, forename, index;

                // separate the forename and surname
                if (value.indexOf(",") > -1) {
                    name = value.split(",");
                    surname = name[0];
                    forename = name[1];

                } else {
                    index = value.lastIndexOf(" ");
                    forename = value.substring(0, index);
                    surname = value.substring(index + 1);
                }

                if (!!forename) {
                    forename = forename.trim();
                    valueChanged = user.forename.value != forename;

                    user.forename.value = forename;
                    user.forename.locked = !!locked;
                }

                if (!!surname) {
                    surname = surname.trim();
                    valueChanged = valueChanged || user.surname.value != surname;

                    user.surname.value = surname;
                    user.surname.locked = !!locked;
                }
            }
        }

        if (valueChanged) {
            $rootScope.$emit('v3sUserChanged', this);
        }
    }

    function showUserData(ask) {
        createUserDataVars(!modal); //reset vars, falls neues Modal

        if (!modal && vars) {
            if (!!ask) {
                modal = v3sModal.show({
                    title: "dialogs.user.title.ask",
                    message: "dialogs.user.message.ask",
                    vars: vars,
                    customClass: "userdata",
                    actions: {
                        "dialogs.user.buttons.continue": function () {
                            updateUserDataVars();
                            v3sModal.hide(modal);
                            modal = null;
                        }
                    },
                    onHide: function () {
                        modal = null;
                    }
                });
            } else {
                modal = v3sModal.show({
                    title: "dialogs.user.title.edit",
                    message: "dialogs.user.message.edit",
                    customClass: "userdata",
                    vars: vars,
                    actions: {
                        "dialogs.user.buttons.apply": function () {
                            updateUserDataVars();
                            v3sModal.hide(modal);
                            modal = null;
                        },
                        "dialogs.user.buttons.cancel": function () {
                            v3sModal.hide(modal);
                            modal = null;
                        }
                    },
                    onHide: function () {
                        modal = null;
                    }
                });
            }
        }
    }

    function createUserDataVars(reset) {
        if (!!reset) {
            vars = [];
        }
        var index = 0;
        var editable = false;
        angular.forEach(user, function (param, key) {
            if (param.ask || !!param.value) {
                if (!vars[index]) {
                    vars[index] = { key: key, title: "dialogs.user.vars." + key, value: param.value, locked: param.locked, required: param.required };
                }
                if (!param.locked) {
                    editable = true;
                }
            }
            index++;
        });

        return editable;
    }

    function updateUserDataVars() {
        angular.forEach(vars, function (param) {
            if (!param.locked) {
                set(param.key, param.value);
            }
        });

        changed = true;
    }

    function setUserScormData(data) {
        if (!!data) {
            angular.forEach(data, function (param, key) {
                set(key, param[0], false, param[1]);
            });
        }
    }

    function getUserScormData() {
        var data = {};

        angular.forEach(user, function (param, key) {
            if (!param.locked && param.ask) {
                data[key] = [param.value, param.required];
            }
        });

        return data;
    }


    function getChangeCount() {
        return changed ? 1 : 0;
    }

    function resetChangeCount() {
        changed = false;
    }

    return {
        get: get,
        set: set,
        isUserDataExists: function () { return createUserDataVars() && !modal; },
        showUserData: function () { showUserData(false); },
        hideUserData: function () { v3sModal.hide(modal); },
        getUserScormData: getUserScormData,
        setUserScormData: setUserScormData,
        getChangeCount: getChangeCount,
        resetChangeCount: resetChangeCount
    }
}]);